import { cardIdBelongsToSet } from './setMerges';

// Muted color-per-series palette for SeriesGrid headers.
export const SERIES_COLORS = {
  'Scarlet & Violet': '#7c3aed',
  'Sword & Shield': '#2563eb',
  'Sun & Moon': '#d97706',
  'XY': '#16a34a',
  'Black & White': '#374151',
  'HeartGold & SoulSilver': '#9f1239',
  'Diamond & Pearl': '#0891b2',
  'Platinum': '#0e7490',
  'EX': '#be185d',
  'E-Card': '#a16207',
  'Neo': '#4d7c0f',
  'Gym': '#b91c1c',
  'Base': '#1e40af',
  'POP': '#7c2d12',
  'NP': '#78716c',
  'Mega Evolution': '#9333ea',
  'Other': '#57534e',
};

export const DEFAULT_SERIES_COLOR = '#475569';

export const getSeriesColor = (series) => SERIES_COLORS[series] || DEFAULT_SERIES_COLOR;

// Series names ordered newest era first, by each series' most recent set
// release. Relies on getSeriesGroups already sorting each series' sets
// newest-first, so [0] is the latest set.
export const sortSeriesByLatest = (seriesGroups) => {
  return Object.keys(seriesGroups).sort((a, b) => {
    const latestA = seriesGroups[a][0]?.releaseDate || '0000';
    const latestB = seriesGroups[b][0]?.releaseDate || '0000';
    return new Date(latestB) - new Date(latestA);
  });
};

// Owned-unique / printed-total across every set in a series, derived from
// already-loaded set metadata + collection keys — no extra fetches. Shared
// by SeriesGrid (per-card "Done" stat) and Dashboard (progress bars).
export const getSeriesCompletion = (seriesSets, collection) => {
  let total = 0;
  let owned = 0;

  seriesSets.forEach((set) => {
    total += set.total || 0;
    Object.keys(collection).forEach((cardId) => {
      if (!cardIdBelongsToSet(cardId, set.id)) return;
      const qty = Object.values(collection[cardId]).reduce((sum, q) => sum + q, 0);
      if (qty > 0) owned += 1;
    });
  });

  const percentage = total > 0 ? Math.round((owned / total) * 100) : 0;
  return { owned, total, percentage };
};
